const CardList = {
    "LAOACS_I": [
        {
            "title": "Access Your Account",
            "icon": "login",
            "buttonText": "Log In",
            "onButtonClick": "function() { }", 
        },       
        {
            "title": "Explore Permits Map",
            "icon": "map",
            "buttonText": "View Map",
            "onButtonClick": "handleShowPermitsClick",
        },
        {
            "title": "Need Help? Reach Out",
            "icon": "contact_mail",
            "buttonText": "Get in Touch",
            "onButtonClick": "handleContactUsClick"
        },
        {
            "title": "Find Help and FAQs",
            "icon": "help",
            "buttonText": "Support",
            "onButtonClick": "handleHelpUsInternalClick"
        },      
    ],
    "LAOACS_E": [
        {
            "title": "Access Your Account",
            "icon": "login",
            "buttonText": "Log In",
            "onButtonClick": "function() { }"
        },
        {
            "title": "New User? Register Here",
            "icon": "account_circle",
            "buttonText": "Sign Up",
            "onButtonClick": "handleSignConfirmClick"
        },
        {
            "title": "Explore Permits Map",
            "icon": "map",
            "buttonText": "View Map",
            "onButtonClick": "handleShowPermitsClick"
        },
        {
            "title": "Need Help? Reach Out",
            "icon": "contact_mail",
            "buttonText": "Get in Touch",
            "onButtonClick": "handleContactUsClick"
        },
        {
            "title": "Find Help and FAQs",
            "icon": "help",
            "buttonText": "Support",
            "onButtonClick": "handleHelpUsClick"
        }
    ]
}

export default CardList